import React from 'react'
import Text from '../../../Text'
import SimpleBlockContent from '../../../SimpleBlockContent'
import Img from '../../../Img'
import CtaV2 from '../../../CtaV2'
import HighlightedText from '../../../Utils/HighlightedText'
import CheckmarkIconRed from '../../../icons/CheckmarkIconRed'
import styles from './styles.module.css'
import { $textTertiary } from '../../../../styles/colors/semantics'

function HardwarePage({ titleHl, subtitleHl, ctaV2, features, perks, headerImageCs }) {
  return (
    <div>
      <section className="flex flex-col">
        <div className="relative flex flex-1 px-[5%] py-8 items-center justify-center ">
          <div className="container relative h-64 md:h-100 overflow-hidden rounded-[32px]">
            {/* LCP of the hardware landing page: canonical <Img> filling the
                container, eager + fetchPriority so the largest paint starts from
                the SSR HTML (task #67). headerImageCs.image is a pre-resolved
                descriptor (walker). */}
            <Img
              image={headerImageCs.image}
              alt={headerImageCs.alt || 'VRS DirectForce hardware'}
              sizes="(max-width: 768px) 100vw, 1200px"
              priority
              objectFit="cover"
              className="rounded-[32px]"
            />
          </div>

        </div>
        <div className="px-[5%] flex items-center justify-center">
          <div className="relative container">
            <div className="w-full grid grid-rows-1 items-start gap-y-5 py-12 md:grid-cols-2 md:grid-cols-[1.5fr_1fr] md:gap-x-12 md:gap-y-8 md:py-18 lg:gap-x-20 lg:gap-y-16 lg:py-20">
              <div className="flex flex-col gap-16">
                <div className="flex flex-col gap-2">
                  <Text type="heading-8">VRS® DirectForce® Sim Racing Hardware</Text>
                  {/* Single-<h1> rule (Audit A #1): /hardware index hero title is
                      the page's one visible <h1>. `.h1-contents` adds no box. */}
                  <h1 className="h1-contents">{ <HighlightedText {...titleHl}/> }</h1>
                </div>
                <CtaV2 {...ctaV2}/>
              </div>
              <div>
                <div className="mt-6 flex flex-wrap gap-8 md:mt-8">
                  { <HighlightedText {...subtitleHl}/> }
                  <div className="grid md:grid-cols-2 md:gap-x-4 gap-y-3 md:gap-y-4">
                      { perks.map(p =>
                        <div className="flex gap-2 items-center" key={p.title}>
                          <div className={`${styles.perkIconWrapper} size-6`}>
                            <CheckmarkIconRed/>
                          </div>
                          <div className="flex flex-col">
                            <Text type="regular">{p.title}</Text>
                            <Text type="tiny" color={$textTertiary.light}>{p.text}</Text>
                          </div>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  )
}



export default HardwarePage
